import { render } from "./AboutComponent.vue?vue&type=template&id=03f4d222"
const script = {}

import "./AboutComponent.vue?vue&type=style&index=0&id=03f4d222&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__